import React from "react";
import { api } from "@/lib/api";

// Starts the real Stripe Checkout for the chosen plan. Navigates the TOP-LEVEL
// window (preview runs in an iframe; Stripe refuses framing). Premium is only
// granted server-side after Stripe confirms (never trusted from the frontend).
export async function startCheckout(planId = "premium_monthly") {
  const { data } = await api.post("/payments/checkout", {
    origin_url: window.location.origin,
    plan_id: planId,
  });
  const url = data.checkout_url;
  try {
    if (window.top && window.top !== window.self) {
      window.top.location.href = url;
      return;
    }
  } catch (error) {
    console.warn("startCheckout: could not access top window, using same-window nav", error);
  }
  window.location.href = url;
}
